export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ07.db981af2.mp3";